import { DOCS_FORM_NAMES } from "core/consts";
import { getGKVMedicalFormSchema } from "core/schemas/GKVMedicalFormSchema";
import { importAuctionToGKVMedicalForm } from "dsl/ecosystems/PatientForms/RehabForms/GKVMedicalForm/importAuction";
import { FormFieldConfigFactory } from "..";
import { GKVMedicalFormSections } from "./sections";

export const getGKVMedicalFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.GKV_MEDICAL
> = ({ skipRequiredValidation, translations }) => {
  return {
    auctionToForm: importAuctionToGKVMedicalForm,
    getInitialValue: ({ patient, rehabForms, value }) => {
      return {
        admission_date: value?.admission_date ?? null,
        approved_by:
          value?.approved_by ?? rehabForms?.medical_form?.approved_by ?? null,
        complication_cause_cardiovascular:
          value?.complication_cause_cardiovascular ?? false,
        complication_cause_cardiovascular_description:
          value?.complication_cause_cardiovascular_description ?? "",
        complication_cause_maindiagnosis:
          value?.complication_cause_maindiagnosis ?? false,
        complication_cause_maindiagnosis_description:
          value?.complication_cause_maindiagnosis_description ?? "",
        complication_cause_other: value?.complication_cause_other ?? false,
        complication_cause_other_description:
          value?.complication_cause_other_description ?? "",
        complication_in_treatment_process:
          value?.complication_in_treatment_process ?? null,
        discharge_date: value?.discharge_date ?? null,
        doctor_exam_date: value?.doctor_exam_date ?? null,
        doctor_in_charge_in_hospital_first_name:
          value?.doctor_in_charge_in_hospital_first_name ?? "",
        doctor_in_charge_in_hospital_last_name:
          value?.doctor_in_charge_in_hospital_last_name ?? "",
        doctor_in_charge_in_hospital_phone:
          value?.doctor_in_charge_in_hospital_phone ?? "",
        early_rehabilitation_measures:
          value?.early_rehabilitation_measures ?? null,
        gender: value?.gender ?? null,
        hospital_ik_number:
          value?.hospital_ik_number ??
          patient.careseeker?.company?.ik_numbers?.[0]?.toString() ??
          null,
        icd_code_1_code: value?.icd_code_1_code ?? "",
        icd_code_1_diagnosis: value?.icd_code_1_diagnosis ?? "",
        icd_code_1_reason: value?.icd_code_1_reason ?? null,
        icd_code_2_code: value?.icd_code_2_code ?? "",
        icd_code_2_diagnosis: value?.icd_code_2_diagnosis ?? "",
        icd_code_2_reason: value?.icd_code_2_reason ?? null,
        icd_code_3_code: value?.icd_code_3_code ?? "",
        icd_code_3_diagnosis: value?.icd_code_3_diagnosis ?? "",
        icd_code_3_reason: value?.icd_code_3_reason ?? null,
        icd_code_4_code: value?.icd_code_4_code ?? "",
        icd_code_4_diagnosis: value?.icd_code_4_diagnosis ?? "",
        icd_code_4_reason: value?.icd_code_4_reason ?? null,
        icd_code_5_code: value?.icd_code_5_code ?? "",
        icd_code_5_diagnosis: value?.icd_code_5_diagnosis ?? "",
        icd_code_5_reason: value?.icd_code_5_reason ?? null,
        infections: value?.infections ?? "",
        infections_state: value?.infections_state ?? null,
        insurance_ik_number:
          value?.insurance_ik_number ??
          patient.profile?.financing?.insurance?.ik_number?.toString() ??
          null,
        insurance_number: value?.insurance_number ?? "",
        interim_prosthesis_fitted: value?.interim_prosthesis_fitted ?? null,
        internal_complications_hide_error:
          value?.internal_complications_hide_error ?? false,
        limited_capacity: value?.limited_capacity ?? null,
        operation_1_date: value?.operation_1_date ?? null,
        operation_1_ops: value?.operation_1_ops ?? null,
        operation_1_wound_closed: value?.operation_1_wound_closed ?? null,
        operation_2_date: value?.operation_2_date ?? null,
        operation_2_ops: value?.operation_2_ops ?? null,
        operation_2_wound_closed: value?.operation_2_wound_closed ?? null,
        operation_3_date: value?.operation_3_date ?? null,
        operation_3_ops: value?.operation_3_ops ?? null,
        operation_3_wound_closed: value?.operation_3_wound_closed ?? null,
        operation_4_date: value?.operation_4_date ?? null,
        operation_4_ops: value?.operation_4_ops ?? null,
        operation_4_wound_closed: value?.operation_4_wound_closed ?? null,
        operation_5_date: value?.operation_5_date ?? null,
        operation_5_ops: value?.operation_5_ops ?? null,
        operation_5_wound_closed: value?.operation_5_wound_closed ?? null,
        other_treatments: value?.other_treatments ?? "",
        patient_birthdate: value?.patient_birthdate ?? null,
        patient_first_name: value?.patient_first_name ?? "",
        patient_last_name: value?.patient_last_name ?? "",
        recommended_reha_type: value?.recommended_reha_type ?? null,
        recommended_reha_type_reason: value?.recommended_reha_type_reason ?? "",
        reha_capacity: value?.reha_capacity ?? null,
        reha_capacity_early_rehab_criteria:
          value?.reha_capacity_early_rehab_criteria ?? null,
        reha_capacity_other: value?.reha_capacity_other ?? "",
        reha_capacity_partial: value?.reha_capacity_partial ?? "",
        rehab_admission_outside_two_weeks_explanation:
          value?.rehab_admission_outside_two_weeks_explanation ?? "",
        rehab_admission_outside_two_weeks_start_date:
          value?.rehab_admission_outside_two_weeks_start_date ?? null,
        rehab_admission_type: value?.rehab_admission_type ?? null,
        rehab_admission_within_two_weeks_start_date:
          value?.rehab_admission_within_two_weeks_start_date ?? null,
        rehab_directive_state: value?.rehab_directive_state ?? null,
        rehab_directive_type: value?.rehab_directive_type ?? null,
        rehab_focus: value?.rehab_focus ?? null,
        rehab_focus_other_description:
          value?.rehab_focus_other_description ?? "",
        rehabilitation_goals: value?.rehabilitation_goals ?? "",
        require_accompanying_person: value?.require_accompanying_person ?? null,
        singer_assessment_concentration:
          value?.singer_assessment_concentration ?? null,
        singer_assessment_date: value?.singer_assessment_date ?? null,
        singer_assessment_domestic_life_household:
          value?.singer_assessment_domestic_life_household ?? null,
        singer_assessment_dressing_and_undressing:
          value?.singer_assessment_dressing_and_undressing ?? null,
        singer_assessment_food: value?.singer_assessment_food ?? null,
        singer_assessment_hygiene: value?.singer_assessment_hygiene ?? null,
        singer_assessment_listening: value?.singer_assessment_listening ?? null,
        singer_assessment_orientation:
          value?.singer_assessment_orientation ?? null,
        singer_assessment_planning: value?.singer_assessment_planning ?? null,
        singer_assessment_reading: value?.singer_assessment_reading ?? null,
        singer_assessment_shower: value?.singer_assessment_shower ?? null,
        singer_assessment_social_interaction:
          value?.singer_assessment_social_interaction ?? null,
        singer_assessment_stairs: value?.singer_assessment_stairs ?? null,
        singer_assessment_stool: value?.singer_assessment_stool ?? null,
        singer_assessment_talking: value?.singer_assessment_talking ?? null,
        singer_assessment_toilet_use:
          value?.singer_assessment_toilet_use ?? null,
        singer_assessment_transfer: value?.singer_assessment_transfer ?? null,
        singer_assessment_urination: value?.singer_assessment_urination ?? null,
        singer_assessment_walking: value?.singer_assessment_walking ?? null,
        singer_assessment_wheelchair:
          value?.singer_assessment_wheelchair ?? null,
        singer_assessment_writing: value?.singer_assessment_writing ?? null,
        special_requirements: value?.special_requirements ?? null,
        special_requirements_decubitus_description:
          value?.special_requirements_decubitus_description ?? "",
        special_requirements_dialysis_description:
          value?.special_requirements_dialysis_description ?? "",
        special_requirements_other_description:
          value?.special_requirements_other_description ?? "",
        special_requirements_relatives_description:
          value?.special_requirements_relatives_description ?? "",
        special_requirements_required:
          value?.special_requirements_required ?? null,
        special_requirements_weight_bed_description:
          value?.special_requirements_weight_bed_description ?? "",
        surgery_performed: value?.surgery_performed ?? null,
        transport_type: value?.transport_type ?? null,
        transport_type_ambulance_description:
          value?.transport_type_ambulance_description ?? "",
        transport_type_ambulance_specification:
          value?.transport_type_ambulance_specification ?? null,
        transport_type_taxi_specification:
          value?.transport_type_taxi_specification ?? null,
      };
    },
    header: ({ translations }) =>
      translations.extractDocs.splitView.header.titleGkvForm,
    schema: getGKVMedicalFormSchema({
      skipRequiredValidation,
      translations,
    }),
    sections: GKVMedicalFormSections,
    title: ({ translations }) => translations.patientForms.medicalForm.title,
  };
};
